import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'

export const requestHelpMounted = createEvent<{
  transactionRequestId: number
  managerEmail: string
  question: string
}>()

export const closeModal = createEvent()

export const requestHelp = fx<
  {
    transactionRequestId: number
    managerEmail: string
    question: string
  },
  void
>({
  method: 'POST',
  url: '/transaction_request/developer_assistance',
})

sample({
  clock: requestHelpMounted,
  fn: (params) => {
    return {
      url: `/transaction_request/developer_assistance`,
      body: {
        ...params,
      },
    }
  },
  target: requestHelp,
})

export const $isSuccess = restore(
  requestHelp.doneData.map(() => true),
  false,
).reset(closeModal)
